import React, {useEffect, useMemo, useState} from "react";
import {Prompt} from "react-router-dom";
import {Button, CircularProgress, Divider, Typography} from "@mui/material";
import {AccountAvatar} from "@atttomyx/react-components";
import {TypeForm, TypeRoleForm} from "../forms";
import {internalTypeService} from "../../services";
import {arrays, forms} from "@atttomyx/shared-utils";
import {verbiage} from "@atttomyx/shared-constants";
import "./addTypePage.css";

const freshData = () => {
    return {
        title: null,
        description: null,
        valid: false,
    }
};

const freshRoles = () => {
    return {
        roles: [],
        valid: true,
    }
};

const AddTypePage = (props) => {
    const { snackbar, match, apps, accounts, onSave } = props;
    const [ account, setAccount ] = useState({})
    const [ data, setData ] = useState(freshData());
    const [ roles, setRoles ] = useState(freshRoles());
    const [ saving, setSaving ] = useState(false);

    useEffect(() => {
        const accountId = match.params.accountId;

        setAccount(arrays.findEntity(accounts, accountId));
    }, []);

    const app = useMemo(() => {
        return account ? apps.find(candidate => candidate.id === account.appId) : null;
    }, [apps, account]);

    const available = useMemo(() => {
        return app ? app.roles : [];
    }, [app]);

    const resetForm = () => {
        setData(freshData());
        setRoles(freshRoles());
    }

    const submitForm = () => {
        setSaving(true);

        const added = {
            title: data.title,
            description: data.description,
            roles: roles.roles,
        };

        const success = (user) => {
            resetForm();
            setSaving(false);

            snackbar.setSuccess("Type saved");
            onSave(account.id, user);
        };

        const failure = (err) => {
            setSaving(false);
            snackbar.setError(err);
        };

        internalTypeService.createType(account.id, added, success, failure);
    }

    const valid = data.valid && account;
    const modified = forms.differ(freshData(), data) || forms.differ(freshRoles(), roles);

    return saving ?
        <div className="add-type-page">
            <CircularProgress size="80px"/>
        </div> :
        <div className="add-type-page">
            {account ?
                <>
                    <AccountAvatar
                        account={account}
                        mode="no-title"
                        size={account.branding && account.branding.logoContainsName ? "plus" : "medium"}
                    />
                    {account.branding && !account.branding.logoContainsName ?
                        <Typography variant="caption">
                            {account.name}
                        </Typography> : null}
                    <Divider/>
                </> : null}
            <div className="cards">
                <div className="card">
                    <TypeForm
                        data={data}
                        onChange={setData}
                    />
                </div>
                <div className="card">
                    <TypeRoleForm
                        roles={available}
                        data={roles}
                        onChange={setRoles}
                    />
                </div>
            </div>
            <div className="actions">
                <Button color="secondary" variant="text"
                        disabled={!modified}
                        onClick={resetForm}>
                    Undo
                </Button>
                <Button color="primary" size="large"
                        disabled={!valid || !modified}
                        onClick={submitForm}>
                    Save
                </Button>
            </div>
            <Prompt when={modified} message={verbiage.UNSAVED_CHANGES}/>
        </div>
}

export default AddTypePage;
